import { CampaignRanking } from '@/domain/types/campaigns';
import { utils, writeFile } from 'xlsx';

export function exportMentionsToExcel(
  rankings: CampaignRanking[],
  campaignName: string,
): void {
  const data = rankings.map((r, i) => ({
    'Posición': i + 1,
    'Documento': r.document,
    'Nombre': r.name,
    'Menciones': r.mentionCount,
    'Última mención': r.lastMentionAt?.toDate().toLocaleDateString('es-CO') ?? '',
  }));

  const ws = utils.json_to_sheet(data);
  const wb = utils.book_new();
  utils.book_append_sheet(wb, ws, 'Ranking');

  const safeFileName = campaignName.replace(/[^a-z0-9]/gi, '-').toLowerCase();
  writeFile(wb, `ranking-${safeFileName}.xlsx`);
}
